<template>
  <div>
    <Loading :loading="loading" :diameter="400" />
    <accordion v-if="!loading">
      <md-table v-model="table.mdData" md-card>
        <md-table-toolbar>
          <div class="row" style="width: 100%">
            <div class="col-6">
              <h1 class="md-title">Logs</h1>
              <p class="md-subheading" style="margin-left: 8px">
                Horario baseado no fuso do Local
              </p>
            </div>
            <div class="col-6" style="text-align: right">
              <md-button class="md-primary" @click="$router.back()">
                Voltar
              </md-button>
              <md-button
                v-if="table.mdPage !== 1"
                class="md-raised"
                @click="
                  () => {
                    updatePagination(--table.mdPage, rowsPerPage)
                  }
                "
              >
                Mais recente
              </md-button>
              <md-button
                class="md-raised md-primary"
                @click="
                  () => {
                    updatePagination(++table.mdPage, rowsPerPage)
                  }
                "
              >
                Mais antigo
              </md-button>
            </div>
          </div>
        </md-table-toolbar>
        <md-table-row slot="md-table-row" slot-scope="{ item }">
          <accordion-item>
            <template slot="accordion-trigger">
              <h3>
                {{
                  formatDate(item.horario) + (item.ativado ? ' - Ativado' : '')
                }}
              </h3>
            </template>
            <template slot="accordion-content">
              <NotificacaoLog :logs="item.log" />
            </template>
          </accordion-item>
        </md-table-row>
      </md-table>
    </accordion>
  </div>
</template>

<script>
import moment from 'moment-timezone'

import Accordion from '../../../components/accordion/Accordion'
import AccordionItem from '../../../components/accordion/AccordionItem'
import Loading from '../../../components/Loading'
import NotificacaoLog from '../../../components/notificacao/logs/NotificacaoLog'
import http from '../../../utils/http'

export default {
  name: 'NotificacaoLogDetalhe',
  // eslint-disable-next-line vue/no-unused-components
  components: { Loading, Accordion, AccordionItem, NotificacaoLog },
  data() {
    return {
      table: {
        mdCount: null,
        mdPage: 1,
        mdData: [],
      },
      loading: true,
      rowsPerPage: 10,
      logs: [],
      localId: null,
      notificacaoId: null,
    }
  },
  beforeMount() {
    this.localId = this.$route.params.localId
    this.notificacaoId = this.$route.params.notificacaoId

    this.updatePagination(1, this.rowsPerPage)
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    async updatePagination(page, pageSize, _sort, _sortOrder) {
      this.loading = true

      const logs = (
        await http.get(`notificacao/${this.notificacaoId}/log`, {
          page,
          pageSize,
        })
      ).logs

      this.table = {
        ...this.table,
        mdData: logs,
      }
      this.loading = false
      return true
    },
    formatDate(string) {
      if (!string) {
        return '-'
      }

      return moment(string).format('DD/MM/YYYY à\\s H:mm:ss')
    },
  },
}
</script>

<style scoped></style>
